<template>
  <div>
    <header-top></header-top>
    <div class="shelves-content">
      <div class="main-width">
        <!-- 侧边栏 shelves-left -->
        <div class="shelves-left">
          <el-col>
            <el-menu
              :default-active="defaultActive"
              class="el-menu-vertical-demo"
              :default-openeds="defaultOpen"
              @select="setStatus"
            >
              <el-submenu index="1">
                <template slot="title">我的货架</template>
                <!-- <div slot="title" class='slide-title'>

                  全部商品
                </div>-->
                <el-menu-item index="1-0" :default-active="true">
                  <template slot="title">全部 （{{kindNumber.all}}）</template>
                </el-menu-item>
                <el-menu-item index="1-1">
                  <template slot="title">未生效 ({{kindNumber.noSend}})</template>
                </el-menu-item>
                <el-menu-item index="1-2">
                  <template slot="title">有更优价格 （{{kindNumber.betterPrice}}）</template>
                </el-menu-item>
                <el-menu-item index="1-3">
                  <template slot="title">货源已涨价 （{{kindNumber.riseFailure}}）</template>
                </el-menu-item>
                <el-menu-item index="1-4">
                  <template slot="title">断货 （{{kindNumber.noInventory}}）</template>
                </el-menu-item>
                <el-menu-item index="1-7">
                  <template slot="title">区域断货 （{{kindNumber.duangong}}）</template>
                </el-menu-item>
                <el-menu-item index="1-6">
                  <template slot="title">自产自销 （{{kindNumber.isOwnsNum}}）</template>
                </el-menu-item>
                <el-menu-item index="1-5">
                  <template slot="title">正常生效 （{{kindNumber.normalSales}}）</template>
                </el-menu-item>
                <!-- <el-menu-item index="1-6">
                  <template slot="title">商品回收站 （{{kindNumber.collect}}）</template>
                </el-menu-item>-->
              </el-submenu>
              <el-menu-item index="2" class="shopCar" @click="onRecycle()">
                <span slot="title">商品回收站</span>
                <!-- <template slot="title">采购车</template> -->
              </el-menu-item>
              <el-menu-item
                index="3"
                class="shopCar"
                @click="showShopCar(2)"
                v-if="openPurchasingCart==1"
              >
                <span slot="title">采购车</span>
                <!-- <template slot="title">采购车</template> -->
              </el-menu-item>
            </el-menu>
          </el-col>
        </div>
        <!-- 货架内容  shelves-right -->
        <div class="shelves-right">
          <div class="shelves-right-wrap" v-if="!shopCarShow">
            <!-- 商品货架  start -->
            <div class="goods-shelves" v-show="isShow">
              <div class="shelves-filter-wrap">
                <span class="shelves-input-item">
                  <label>SKU：</label>
                  <span>
                    <input type="text" placeholder="请输入SKU" v-model="condition.productId" />
                  </span>
                </span>
                <span class="shelves-input-item">
                  <label>品牌名称：</label>
                  <span>
                    <input type="text" placeholder="请输入品牌名称" v-model="condition.brandName" />
                  </span>
                </span>
                <span class="shelves-input-item">
                  <label>商品名称：</label>
                  <span>
                    <input type="text" placeholder="请输入商品名称" v-model="condition.goodsName" />
                  </span>
                </span>
                <span class="shelves-input-item">
                  <!-- <label>二级分类：</label>

<span class="classify-query">

  <el-select v-model="condition.categoryTwoName" clearable placeholder="请输入货品编号" size="small">

    <el-option

      v-for="item in resTwoCatagory"

      :key="item.value"

      :label="item.label"

      :value="item.label">

    </el-option>

  </el-select>
                  </span>-->
                  <label>二级分类：</label>
                  <span>
                    <input type="text" placeholder="请输入二级分类" v-model="condition.twoLevel" />
                  </span>
                </span>
                <span class="shelves-input-item">
                  <label>三级分类：</label>
                  <span>
                    <input type="text" placeholder="请输入三级分类" v-model="condition.threeLevel" />
                  </span>
                  <!-- <label>三级分类：</label>

<span class="classify-query">

 <el-select v-model="condition.categoryThreeName" clearable placeholder="请输入货品编号" size="small">

    <el-option

      v-for="item in resThreeCatagory"

      :key="item.value"

      :label="item.label"

      :value="item.label">

    </el-option>

  </el-select>
                  </span>-->
                </span>
                <span style="margin-left:10px">
                  <span class="shelves-filter-btn-default shelves-filter" @click="init">筛选</span>
                  <span class="shelves-filter-btn-default shelves-cancel" @click="clearCondition">取消</span>
                </span>
              </div>
              <div class="mar-top-15 operation">
                <!-- 批量推送 -->
                <!-- <el-dropdown
                  split-button
                  type="primary"
                  trigger="click"
                  class="c-dropdown"
                  size="small"
                  @click="push"
                  :hide-on-click="false"
                >
                  批量推送
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-checkbox v-model="sendUpdateGoods">名称和建议售价</el-checkbox>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="sendUpdateGoodsDetail">主图与详情图</el-checkbox>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-checkbox v-model="sendUpdateSalePrice">实际售价</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
                <div
                  class="batch-operation el-button el-button--primary el-button--small"
                  style="height:30px;margin-left: 0;margin-right: 20px;"
                  @click="newPush(null)"
                >
                  <span>批量推送</span>
                </div>
                <!-- 批量放入回收站 -->
                <div
                  class="batch-operation el-button el-button--primary el-button--small"
                  style="height:30px;"
                  @click="putInbin"
                >
                  <span>批量放入回收站</span>
                </div>
                <!-- <div style="display:flex;" v-if="( condition.status ==99||   condition.status==4)">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="*仅会导出筛选条件下当前生效中可下单的货架信息"
                    placement="right"
                  >
                    <div
                      class="batch-operation el-button el-button--primary el-button--small"
                      style="height:30px;"
                      @click="exportInfo"
                    >
                      <span>货架信息导出</span>
                    </div>
                  </el-tooltip>
                </div> -->

                <div
                  class="batch-operation ineffective-operation el-button el-button--primary el-button--small"
                  style="height:30px;float:right"
                  @click="pushIneffective"
                >推送所有未生效信息</div>
              </div>
              <div>
                <div class="noData" v-if="isShowImg">
                  <img src="../assets/img/erro@2x.png" />
                  <p>暂未发现任何商品</p>
                </div>
                <table class="shelves-table" v-if="!isShowImg">
                  <thead>
                    <tr>
                      <th
                        class="table-header-selectall"
                        :class="{'yigouxuan': isSelect}"
                        @click="allSelect"
                      >全选</th>
                      <th>操作</th>
                      <th>货品SKU</th>
                      <!-- <th>渠道销量</th> -->
                      <th>类型</th>
                      <th>建议售价</th>
                      <th>结算价 (+运费）</th>
                      <th>可供库存</th>
                      <th>是否带票</th>
                      <th>利润率</th>
                      <th>状态</th>
                    </tr>
                    <tr>
                      <td colspan="11" class="self-tbody-space"></td>
                    </tr>
                  </thead>

                  <tbody v-for="(item, index) in goodsList">
                    <tr>
                      <!-- :class="{'yigouxuan': selectItem[index].isSelect}" -->
                      <td
                        colspan="10"
                        class="shelves-table-block-title"
                        :class="{'yigouxuan':  selectItem[index].isSelect}"
                        @click="selectItemAll(index)"
                      >
                        <span>
                          商品品牌：
                          <label>{{item.brand}}</label>
                        </span>
                        <span
                          class="shelves-table-block-name dianshang"
                          v-if="item.channel === 2"
                        >商品名称：{{item.goodsName}}</span>
                        <span
                          class="shelves-table-block-name mendian"
                          v-else-if="item.channel === 1"
                        >商品名称：{{item.goodsName}}</span>
                        <span class="shelves-table-block-name" v-else>商品名称：{{item.goodsName}}</span>

                        <span>
                          <label>{{item.twoLevel}} / {{item.threeLevel}}</label>
                        </span>
                      </td>
                    </tr>
                    <tr
                      class="shelves-table-item hasborder"
                      v-for="(value, index1) in item.goodsShelfDetails"
                      :class="value.skuId==(item.goodsShelfDetails[index1+1]?item.goodsShelfDetails[index1+1].skuId:null)?'tr-td-style':''"
                    >
                      <td
                        class="shelves-table-item-select"
                        @click="selectItemFuc(index, index1)"
                        v-if="selectItem[index].shelvesProduct[index1].isSelect"
                        :class="{'yigouxuan': selectItem[index].shelvesProduct[index1].isChecked}"
                      ></td>
                      <td class="shelves-table-item-default" v-else></td>
                      <td>
                        <div>
                          <div
                            class="font-color-green cursor-pointer shelves-to-detail td-div-marBot"
                            @click="newPush(value.goodsShelfByTypes[0].appRecordId)"
                            v-if="selectItem[index].shelvesProduct[index1].status0 == '0'"
                          >推送</div>

                          <div
                            class="font-color-red cursor-pointer td-div-marBot"
                            v-else-if="selectItem[index].shelvesProduct[index1].status0 == '4'&&openPurchasingCart==1||selectItem[index].shelvesProduct[index1].status0 =='7'&&openPurchasingCart==1"
                            @click="joinCar(item,value)"
                          >加入采购车</div>

                          <div
                            class="font-color-orange cursor-pointer td-div-marBot"
                            @click="newPush(value.goodsShelfByTypes[0].appRecordId)"
                            v-else-if="selectItem[index].shelvesProduct[index1].status1 == '7'"
                          >
                            更新推送
                            <div
                              v-if="openPurchasingCart==1"
                              class="font-color-red cursor-pointer td-div-marBot"
                              @click.stop="joinCar(item,value)"
                            >加入采购车</div>
                          </div>
                          <div
                            class="font-color-orange cursor-pointer td-div-marBot"
                            v-else-if="selectItem[index].shelvesProduct[index1].status1 == '6'"
                            @click="newPush(value.goodsShelfByTypes[0].appRecordId)"
                          >更新推送</div>
                        </div>
                      </td>
                      <td
                        class="shelves-table-item-img"
                        v-if="value.skuId!=(item.goodsShelfDetails[index1-1]?item.goodsShelfDetails[index1-1].skuId:null)"
                        v-bind:rowspan="value.skuId==(item.goodsShelfDetails[index1+1]?item.goodsShelfDetails[index1+1].skuId:null)?2:1"
                      >
                        <div class="shelves-table-item-imgwrap">

                          <router-link
                            tag="a"
                            target="_blank"
                            :to="{name: 'Detail', query: {goodsId: item.goodsId}}"
                          >
                            <img
                              v-bind:src="value.pictureUrl"
                              @error="error(1)"
                              style="top: 50%;transform: translateY(-50%);"
                            />
                          </router-link>
                          <!-- <div class="shixiao" v-if=" selectItem[index].shelvesProduct[index1].isUnEffect == true"></div> -->
                          <img v-if="value.isOwntips == true" style="width: 22px;height: 22px;position: absolute;z-index: 100;top: initial;margin-top: -11px;" src="../assets/img/is_owns.png" alt="">
                        </div>
                        <div class="text-align-left td-div-marBot">{{value.specName}}</div>
                        <div class="text-align-left">
                          SKU：
                          <span>{{value.skuId}}</span>
                        </div>
                      </td>
                      <!-- <td>
                        <span
                          style="color: #fff;background-color:#fea923;padding: 6px 12px;"
                        >{{value.saleNum}}</span>
                      </td> -->
                      <td>
                        <div v-if="value.apiType==2" class="jicai-style">社群集采</div>
                        <div v-else class="jicai-style">一件代发</div>
                      </td>
                      <td>
                        <div
                          class="td-div-marBot"
                          v-for="product in value.goodsShelfByTypes"
                        >¥{{product.salePrice/100}}
                        </div>
                        <el-popover
                          trigger="hover"
                          placement="top"
                          visible-arrow="false"
                          width="300"
                          popper-class="table-popover"
                          v-if="value.goodsShelfByTypes[0].limitPrice == 1"
                        >
                          <div class="popover-center">
                            该商品品牌方控价，请按售价对外销售，擅自降价将会终止供应链供货！
                          </div>
                          <div slot="reference">
                            <div class="price-control-tips">零售控价</div>
                          </div>
                        </el-popover>
                      </td>
                      <td>
                        <div v-for="product in value.goodsShelfByTypes">
                          <div
                            class="font-color-orange td-div-marBot"
                            v-if="value.apiType==2"
                          >¥{{product.coopPrice/100}}</div>
                          <div class="font-color-orange td-div-marBot" v-else>
                            ¥{{product.coopPrice/100}}
                            <span
                              class="goods-freight"
                            >(+{{product.freight/100}})</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div v-for="(product,idx) in value.goodsShelfByTypes">
                          <div
                            class="font-color-orange td-div-marBot"
                            v-if="product.hasTax == 0"
                          >{{product.num}}</div>
                          <div class="font-color-orange td-div-marBot" v-else>{{product.num}}</div>
                          <div style="color: rgb(88, 191, 106);border-radius: 12px;width: 60px;height: 18px;border: 1px solid;font-size: 12px;margin: 0 auto;" v-if="product.isOwns == 1 && idx == value.goodsShelfByTypes.length - 1">自产自销</div>
                        </div>
                      </td>
                      <td>
                        <div v-for="product in value.goodsShelfByTypes">
                          <div class="font-color-orange td-div-marBot" v-if="product.hasTax == 1">带票</div>
                          <div class="font-color-orange td-div-marBot" v-else>不带票</div>
                        </div>
                      </td>
                      <td>
                        <div v-for="product in value.goodsShelfByTypes">
                          <div
                            class="font-color-orange td-div-marBot"
                          >{{product.profit}}%</div>
                        </div>
                      </td>
                      <td>
                        <div>
                          <div
                            class="td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status0 =='3'"
                          >
                            <span>实时价格线</span>
                          </div>
                          <div
                            class="font-color-green cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status0 == '0'"
                          >未推送更新</div>
                          <div
                            class="font-color-green cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status0 == '4'||selectItem[index].shelvesProduct[index1].status0 == '7'"
                          >生效中</div>
                          <div
                            class="font-color-red cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status0 == '1' || selectItem[index].shelvesProduct[index1].status0 == '5'"
                          >断货</div>

                          <div
                            class="font-color-red cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status0 == 'new_1'"
                          >区域断货</div>
                          <div
                            class="font-color-red cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status0 == 'new_2'"
                          >区域断货未推送</div>
                          <div
                            class="font-color-red cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status0 == 'new_3'"
                          >断货未推送</div>
                          <div
                            class="font-color-red cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status0 == '6'"
                          >涨价失效</div>
                        </div>

                        <div v-if="selectItem[index].shelvesProduct[index1].status1 !=='' ">
                          <div>
                            <span
                              v-if="selectItem[index].shelvesProduct[index1].status1 == '0'"
                              class="td-div-marBot"
                            >未推送更新</span>
                            <span
                              v-if="selectItem[index].shelvesProduct[index1].status1 =='3'"
                              class="td-div-marBot"
                            >实时价格线</span>
                          </div>
                          <div
                            class="font-color-green cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status1 == '4'||selectItem[index].shelvesProduct[index1].status1 == '7'"
                          >生效中</div>
                          <div
                            class="font-color-red cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status1 == '5'"
                          >断货</div>
                          <div
                            class="font-color-red cursor-pointer td-div-marBot"
                            v-if="selectItem[index].shelvesProduct[index1].status1 == '6'"
                          >涨价失效</div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="block" v-if="!isShowImg">
                <el-pagination
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :current-page.sync="condition.pageNum"
                  :total="goodsCount"
                  :page-size="50"
                ></el-pagination>
              </div>
            </div>
            <!-- 商品货架  end -->
            <!-- 回收站货架  start -->
            <div class="recycle-bin-shelves" v-show="!isShow">
              <div class="shelves-filter-wrap">
                <span class="shelves-input-item">
                  <label>品牌名称：</label>
                  <span>
                    <input type="text" placeholder="请输入品牌名称" v-model="binFilterObj.brandName" />
                  </span>
                </span>
                <span class="shelves-input-item">
                  <label>商品名称：</label>
                  <span>
                    <input type="text" placeholder="请输入商品名称" v-model="binFilterObj.goodsName" />
                  </span>
                </span>

                <span class="shelves-input-item">
                  <!-- <label>二级分类：</label>

<span class="classify-query">

  <el-select v-model="binFilterObj.categoryTwoName" clearable placeholder="请输入货品编号" size="small">

    <el-option

      v-for="item in resTwoCatagory"

      :key="item.value"

      :label="item.label"

      :value="item.label">

    </el-option>

  </el-select>
                  </span>-->
                  <label>二级分类：</label>
                  <span>
                    <input type="text" placeholder="请输入二级分类" v-model="binFilterObj.categoryTwoName" />
                  </span>
                </span>
                <span class="shelves-input-item">
                  <!-- <label>三级分类：</label>

<span class="classify-query">

  <el-select v-model="binFilterObj.categoryThreeName" clearable placeholder="请输入货品编号" size="small">

    <el-option

      v-for="item in resThreeCatagory"

      :key="item.value"

      :label="item.label"

      :value="item.label">

    </el-option>

  </el-select>
                  </span>-->
                  <label>三级分类：</label>
                  <span>
                    <input
                      type="text"
                      placeholder="请输入三级级分类"
                      v-model="binFilterObj.categoryThreeName"
                    />
                  </span>
                </span>
                <span class="shelves-input-item delete-goods-time">
                  <label>删除时间：</label>
                  <span class="delete-time">
                    <el-date-picker
                      v-model="binFilterObj.deltime"
                      type="daterange"
                      size="mini"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </span>
                </span>
                <span>
                  <span class="shelves-filter-btn-default shelves-filter" @click="binFilter(0)">筛选</span>
                  <span
                    class="shelves-filter-btn-default shelves-cancel"
                    @click="clearbinFilterObj"
                  >取消</span>
                </span>
              </div>
              <div>
                <div class="noData" v-if="isShowbinImg">
                  <img src="../assets/img/erro@2x.png" />
                  <p>暂未发现任何商品</p>
                </div>
                <table class="shelves-table" v-if="!isShowbinImg">
                  <thead>
                    <tr>
                      <th>主图</th>
                      <th width="500px">商品名称</th>
                      <th>品牌名</th>
                      <th>删除时间</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in bingoodsList">
                      <td class="goods-img">
                        <img :src="item.goodsImage" />
                      </td>
                      <td class="goods-name" style="padding-left:50px;text-align:left;">
                        <!-- <b style="text-align:center">电商</b> -->
                        <span>{{item.goodsName}}</span>
                      </td>
                      <td>
                        <span>{{item.brandName}}</span>
                      </td>
                      <td>
                        <span>{{item.createTime}}</span>
                      </td>
                      <td class="operate-button">
                        <router-link :to="{name: 'Detail', query: {goodsId: item.goodsId}}">
                          <span>重新加入货架</span>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="block" v-if="!isShowbinImg">
                <el-pagination
                  layout="prev, pager, next"
                  @current-change="handlebinCurrentChange"
                  :current-page.sync="binFilterObj.pageNum"
                  :total="binGoodsCount"
                  :page-size="50"
                ></el-pagination>
              </div>
            </div>
            <!-- 回收站货架  end -->
          </div>
          <!-- :shopCarShowOrder="shopCarShowOrder"  shopCarShow-->
          <shop-car
            v-if="carIndex == 1&&openPurchasingCart==1"
            ref="shopCar"
            @switchPage="handleSwitchPage"
          ></shop-car>
          <shop-car-go-order
            v-if="carIndex == 2&openPurchasingCart==1"
            ref="shopCarGoOrder"
            @switchPage="handleSwitchPage"
          ></shop-car-go-order>
          <Template-teach
            v-if="carIndex == 3&openPurchasingCart==1"
            ref="templateTeach"
            @switchPage="handleSwitchPage"
          ></Template-teach>
        </div>
      </div>
      <Shop-car-add
        v-if="addCarShowFlag&&openPurchasingCart==1"
        ref="addCar"
        @updateListItem="updateTableData"
      ></Shop-car-add>
    </div>

    <el-dialog
      title="推送方式"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <div>
        <div class="push-content">
          <div class="push-title">温馨提示</div>
          <div>1.API对接客户：请对接技术自己按对应情况处理平台内接收到的推送信息。如果推送过去没有相应的变化请联系自己对接的技术升级或者查询情况。</div>
          <div>2.采购车对接客户：不受任何选择影响，建议使用“新商品推送”即可。</div>
        </div>
        <div class="radio-setting">
          <el-radio v-model="radioValue" label="1">新商品推送</el-radio>
          <el-radio v-model="radioValue" label="2">只推送生效新结算价</el-radio>
          <el-radio v-model="radioValue" label="3">既有商品原链接上更新</el-radio>
        </div>
        <div class="operation" style="text-align: center;margin-top: 30px;">
          <div
            class="batch-operation el-button el-button--primary el-button--small"
            style="height:30px;padding: 0 40px;"
            @click="newPushSure()"
          >
            <span>推送</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerTop from "../components/Header";
import store from "../store/index.js";
import {
  myShelves,
  getCountShelfVo,
  pushNeedSend,
  recordCollect,
  send,
  batchAddCollect,
  // activityOption,
  imgAddress,
  getAllShelfVo,
  exportShelfVoExcel
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import router from "../router/index.js";
import shopCar from "./shopCar";
import shopCarGoOrder from "./shopCarGoOrder";
import ShopCarAdd from "./ShopCarAdd";
import TemplateTeach from "./TemplateTeach";

export default {
  data() {
    return {
      openPurchasingCart: this.$store.state.openPurchasingCart, //0显示 1 隐藏
      userId: this.$store.state.userId,
      carIndex: 0, //控制采购车页面和采购车去订单页面的切换
      loading: {
        exportFlag: false
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      condition: {
        brandName: "",
        goodsName: "",
        productId: "",
        status: 0,
        userId: store.state.userId,
        pageSize: 50,
        pageNum: 1,
        categoryTwoName: "",
        categoryThreeName: "",
        //新改版
        brand: "",
        goodsName: "",
        status: "",
        threeLevel: "",
        twoLevel: "",
        appId: ""
      },
      binFilterObj: {
        appId: localStorage.getItem("appId"),
        brandName: "",
        deltime: "",
        categoryThreeName: "",
        categoryTwoName: "",
        goodsName: "",
        pageSize: 50,
        pageNum: 1
      }, //回收站筛选对象
      kindNumber: {
        betterPrice: 0,
        noInventory: 0,
        normalSales: 0,
        riseFailure: 0,
        collect: 0,
        noSend: 0,
        all: 0,
        duangong: 0,
        isOwnsNum: 0,
      }, //每种类商品的数量
      addCarShowFlag: false, //控制加入采购车的显隐
      searchWordArr: [],
      goodsList: {},
      bingoodsList: [], //回收站商品列表
      selectAll: {},
      selectItem: {},
      isSelect: false,
      isShowImg: false, //当数据为空时  表示是否显示图片（非回收站的商品）
      isShowbinImg: false, //当数据为空时  表示是否显示图片（回收站的商品）
      goodAppRecordIds: {},
      bingoodsIds: [], //存放回收站商品id
      imgAddress: imgAddress,
      goodsCount: 0, //货架商品的数量
      binGoodsCount: 0, //回收站商品的数量
      pageCount: "",
      sendUpdateGoods: false,
      sendUpdateGoodsDetail: false,
      sendUpdateSalePrice: false,
      defaultOpen: ["1"], //侧边栏默认展开
      defaultActive: "1-0", //默认选中第一个
      isShow: true, //是否展示货架右边内容
      shopCarShow: false, //是否显示采购车内容
      shopCarShowOrder: true, //是否显示去订单页面
      dialogVisible: false,
      radioValue: '1',
      pushBool: true,
    };
  },
  components: {
    headerTop,
    shopCar,
    shopCarGoOrder,
    ShopCarAdd,
    TemplateTeach
  },
  mounted() {
    this.kindgoodsCount();
    this.condition.status = null; //默认状态全部
    this.condition.appId = this.$store.state.appId;
    this.init();
    this.binFilter();
  },
  methods: {
    // 批量推送
    newPush(id){
      this.newPushId = id;
      let _this = this;
      _this.dialogVisible = true;
    },
    newPushSure(){
      console.log(this.pushBool)
      if(this.pushBool == true){


      this.pushBool = false;
      var data = {
        goodsAppRecordList: this.goodAppRecordIds,
        sendUpdateGoods: 0,
        sendUpdateGoodsDetail: 0,
        sendUpdateSalePrice: 0,
        userId: this.condition.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      var arr = [];
      if(!this.newPushId){
        for (var i = 0; i < this.selectItem.length; i++) {
          for (var j = 0; j < this.selectItem[i].shelvesProduct.length; j++) {
            if (
              this.selectItem[i].shelvesProduct[j].isChecked == true &&
              this.selectItem[i].shelvesProduct[j].isSelect == true
            ) {
              var opt = {
                goodsAppRecordId: this.selectItem[i].shelvesProduct[j]
                  .goodsAppRecordId
              };
              arr.push(opt);
            }
          }
        }
      }else if(this.newPushId){
        var opt = {
          goodsAppRecordId: this.newPushId
        };
        arr.push(opt);
      }
      if(this.radioValue == 1){
        data.sendUpdateGoods = 1;
      }else if(this.radioValue == 2){
        data.sendUpdateSalePrice = 1;
      }else if(this.radioValue == 3){
        data.sendUpdateGoodsDetail = 1
      }


      this.goodAppRecordIds = arr;
      data.goodsAppRecordList = this.goodAppRecordIds;
      if (this.goodAppRecordIds.length != 0) {
        var url = send;
        fetch(url, data).then(res => {
          this.pushBool = true;
          if (res.code == 10000) {
            var str = res.message;
            toast(str, 1, false);
            this.isSelect = false;
            this.dialogVisible = false;
            this.init();
          } else {
            var str = res.message;
            toast(str, 2, false);
          }
        });
      }
      }
    },
    //货架信息导出
    exportInfo() {
      let _this = this;
      this.$confirm(
        "此操作将导出以下列表中所有生效中的货架信息!",
        "确认导出？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "shelves-confirm",
          type: "warning"
        }
      )
        .then(() => {
          _this.exportInfoStep();
        })
        .catch(() => {});
    },
    exportInfoStep() {
      this.loading.exportFlag = true;
      const url = exportShelfVoExcel;
      var params = this.condition;
      params.appId = this.$store.state.appId;
      params.bodyId = this.$store.state.bodyId;
      let responseType = "arraybuffer";
      fetch(url, params, responseType).then(res => {
        // if(res.code===10000){
        let fileName = res.headers["content-disposition"].substring(
          res.headers["content-disposition"].indexOf("=") + 1
        );
        fileDownload(res.data, fileName);
        this.loading.exportFlag = false;

        // }
      });
    },
    onRecycle() {
      this.isShow = false;
      this.shopCarShow = false;
      this.carIndex = 0;
      this.clearCondition();
      // this.init();
    },
    //左边侧边栏选择事件
    setStatus(val) {
      // if (val == "1-6") {
      //   this.isShow = false;
      //   this.shopCarShow = false;
      //   this.carIndex = 0;
      // } else {
      this.isShow = true;
      this.shopCarShow = false;
      // this.shopCarShow=true;
      this.carIndex = 0;
      this.condition.pageNum = 1;

      if (val == "1-0") {
        this.condition.status = null;
      } else if (val == "1-1") {
        this.condition.status = 0;
      } else if (val == "1-2") {
        this.condition.status = 1;
      } else if (val == "1-3") {
        this.condition.status = 2;
      } else if (val == "1-4") {
        this.condition.status = 3;
      } else if (val == "1-7") {
        //区域断货
        this.condition.status = 5;
      } else if (val == "1-5") {
        //正常生效
        this.condition.status = 4;
      } else if(val == '1-6'){
        //自产自销
        this.condition.status = 6;
      }

      this.clearCondition();
      // this.init();
    },
    error(num) {
      imageError(num, event);
    },

    //货架商品列表的筛选
    init() {
      var data = this.condition;
      var url = getAllShelfVo;
      data.bodyId = this.$store.state.bodyId;
      data.appId = this.$store.state.appId;
      fetch(url, data).then(res => {
        if (res.code == 10000) {
          this.goodsList = res.data.result;
          this.goodsCount = res.data.count;

          if (this.goodsList.length > 0) {
            this.isShowImg = false;
          } else {
            this.isShowImg = true;
          }
          this.goodsList.forEach((goodsItem,goodsIndex) => {
            goodsItem.goodsShelfDetails = goodsItem.goodsShelfDetails.filter(item => item.goodsShelfByTypes.length > 0 )
          })
          this.goodsList = this.goodsList.filter(item => item.goodsShelfDetails.length > 0);
          this.goodsList.forEach((goodsItem,goodsIndex) => {
            goodsItem.goodsShelfDetails.forEach((ownItem,ownIndex) => {
              ownItem.isOwntips = false;
              if(ownIndex == 0){
                if(ownItem.goodsShelfByTypes[0].isOwns == 1){
                  ownItem.isOwntips = true;
                }
              }
              if(ownIndex > 0){
                if(ownItem.goodsShelfByTypes[0].isOwns == 1){
                  ownItem.isOwntips = true;
                }
                if(ownItem.skuId == goodsItem.goodsShelfDetails[ownIndex-1].skuId){
                   if(ownItem.goodsShelfByTypes[0].isOwns == 1){
                     goodsItem.goodsShelfDetails[ownIndex-1].isOwntips = true;
                   }
                }
              }

            })

          })

          var arr = [];
          for (var i = 0; i < this.goodsList.length; i++) {

            var opt = {
              id: i,
              isSelect: false
            };
            var shelvesProduct = [];
            for (
              var j = 0;
              j < this.goodsList[i].goodsShelfDetails.length;
              j++
            ) {
              var obj = {
                id: j,
                isSelect: true,
                isChecked: false,
                goodsAppRecordId: "",
                goodsId: "",
                status0: "",
                status1: "",
                isShow: false
              };
              var item = this.goodsList[i].goodsShelfDetails[j]
                .goodsShelfByTypes[0];

              // 新
              // lineStatus = 1 实时价格线
              // lineStatus = 0 根据status判断状态
              // status = 0 未生效 推送
              // status = 1 有更优 更新推送
              // status = 2 货源涨价
              // status = 3 断货
              // status = 4 正常生效
              // status = 5 区域断货
              // status = 1 || 4 配合openPurchasingCart = 1 显示加入采购车



              // 旧
              // status 1或 status 4 加入采购车  生效中 ()
              // status 0 推送  未推送更新 ()
              // status 1 和linestatus 1 更新推送 实时价格线 ()   更新推送  加入采购车
              // status 3 断货 ()
              // status 5 区域断货 ()
              // status 2  涨价失效 ()
              // status 2和linestatus 1   更新推送 实时价格线 ()   涨价失效
              // status 6和status 7 不显示推送,后面显示推送状态  6区域断货未推送 7 断货未推送
              if (item.status == 0) {
                obj.status0 = "0";
              }

              if (item.status == 2 && item.lineStatus == 1) {
                obj.status0 = "3";
              }

              if (item.status == 4) {
                obj.status0 = "4";
              }

              if (item.status == 1) {
                obj.status0 = "3";
              }
              if (item.status == 3) {
                obj.status0 = "1";
              }

              if (item.status == 5) {
                obj.status0 = "new_1";
              }

              if (item.status == 6) {
                obj.status0 = "new_2"; //
              }

              if (item.status == 7) {
                obj.status0 = "new_3"; //
              }

              var item2 = this.goodsList[i].goodsShelfDetails[j]
                .goodsShelfByTypes[1];
              if (item2) {
                if (item.status == 2 && item.lineStatus == 1) {
                  obj.status1 = "6";
                }

                if (item.status == 1) {
                  obj.status1 = "7";
                }
              }

              // console.log("obj", obj);

              obj.goodsId = this.goodsList[i].goodsId;
              obj.goodsAppRecordId = item.appRecordId;

              shelvesProduct.push(obj);
            }
            opt.shelvesProduct = shelvesProduct;
            arr.push(opt);
          }
          this.selectItem = arr;
        } else {
          toast(res.message, 2, false);
        }
      });
    },

    //得到每个种类的商品数量
    kindgoodsCount() {
      var data = {};
      data.appId = localStorage.getItem("appId");
      data.userId = store.state.userId;

      var url = getCountShelfVo;
      fetch(url, data).then(res => {
        if (res.code == 10000) {
          this.kindNumber.all = res.data.count;
          res.data.result.forEach(e => {
            switch (+e.type) {
              case 0:
                this.kindNumber.noSend = e.count;
                break;
              case 4:
                this.kindNumber.normalSales = e.count;
                break;
              case 3:
                this.kindNumber.noInventory = e.count;
                break;
              case 1:
                this.kindNumber.betterPrice = e.count;
                break;
              case 99:
                this.kindNumber.all = e.count;
                break;
              case 2:
                this.kindNumber.riseFailure = e.count;
                break;
              case 5:
                this.kindNumber.duangong = e.count;
                break;
              case 6:
                this.kindNumber.isOwnsNum = e.count;
                break;
            }
          });

        }
      });
    },
    //回收站的筛选出来的商品 ||回收站的商品列表
    binFilter(type) {
      if (type == 0) {
        this.binFilterObj.pageNum = 1;
      }
      if (this.binFilterObj.deltime !== "") {
        var startTime = new Date(this.binFilterObj.deltime[0]);
        var endTime = new Date(this.binFilterObj.deltime[1]);
        startTime =
          startTime.getFullYear() +
          "-" +
          (startTime.getMonth() + 1) +
          "-" +
          startTime.getDate();
        endTime =
          endTime.getFullYear() +
          "-" +
          (endTime.getMonth() + 1) +
          "-" +
          endTime.getDate();
      }

      var data = {};
      data.appId = this.binFilterObj.appId;
      data.brandName = this.binFilterObj.brandName;
      data.categoryTwoName = this.binFilterObj.categoryTwoName;
      data.categoryThreeName = this.binFilterObj.categoryThreeName;
      data.goodsName = this.binFilterObj.goodsName;
      data.startTime = startTime;
      data.endTime = endTime;
      data.pageNum = this.binFilterObj.pageNum;
      data.pageSize = 50;
      data.userId = store.state.userId;
      data.bodyId = store.state.bodyId;
      data.appId = store.state.appId;

      var url = recordCollect;

      fetch(url, data).then(res => {
        if (res.code == 10000) {
          this.binGoodsCount = res.data.count;
          if (res.data.resultGoods.length > 0) {
            this.isShowbinImg = false;
            this.bingoodsList = res.data.resultGoods;
            console.log(res.data.resultGoods);
          } else {
            this.isShowbinImg = true;
            this.bingoodsList = res.data.resultGoods;
          }
        } else {
          toast(res.message, 2, false);
        }
      });
    },
    selectItemAll(id) {
      this.selectItem[id].isSelect = !this.selectItem[id].isSelect;
      for (var i = 0; i < this.selectItem[id].shelvesProduct.length; i++) {
        this.selectItem[id].shelvesProduct[i].isChecked = this.selectItem[
          id
        ].isSelect;
      }
    },
    selectItemFuc: function(index, indexone) {
      this.selectItem[index].shelvesProduct[indexone].isChecked = !this
        .selectItem[index].shelvesProduct[indexone].isChecked;
    },
    allSelect() {
      this.isSelect = !this.isSelect;
      for (var i = 0; i < this.selectItem.length; i++) {
        this.selectItem[i].isSelect = this.isSelect;
        for (var j = 0; j < this.selectItem[i].shelvesProduct.length; j++) {
          this.selectItem[i].shelvesProduct[j].isChecked = this.isSelect;
        }
      }
      console.log(this.selectItem);
    },
    //批量推送
    push() {
      var data = {
        goodsAppRecordList: this.goodAppRecordIds,
        sendUpdateGoods: 0,
        sendUpdateGoodsDetail: 0,
        sendUpdateSalePrice: 0,
        userId: this.condition.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      var arr = [];
      for (var i = 0; i < this.selectItem.length; i++) {
        for (var j = 0; j < this.selectItem[i].shelvesProduct.length; j++) {
          if (
            this.selectItem[i].shelvesProduct[j].isChecked == true &&
            this.selectItem[i].shelvesProduct[j].isSelect == true
          ) {
            var opt = {
              goodsAppRecordId: this.selectItem[i].shelvesProduct[j]
                .goodsAppRecordId
            };
            arr.push(opt);
            console.log(111);
            console.log(arr);
          }
        }

        if (this.sendUpdateGoods == true) {
          data.sendUpdateGoods = 1;
        } else {
          data.sendUpdateGoods = 0;
        }

        if (this.sendUpdateGoodsDetail == true) {
          data.sendUpdateGoodsDetail = 1;
        } else {
          data.sendUpdateGoodsDetail = 0;
        }

        if (this.sendUpdateSalePrice == true) {
          data.sendUpdateSalePrice = 1;
        } else {
          data.sendUpdateSalePrice = 0;
        }
      }
      this.goodAppRecordIds = arr;
      console.log(arr);
      console.log(this.goodAppRecordIds);
      data.goodsAppRecordList = this.goodAppRecordIds;
      console.log(this.goodAppRecordIds);

      if (this.goodAppRecordIds.length != 0) {
        var url = send;
        fetch(url, data).then(res => {
          if (res.code == 10000) {
            var str = res.message;
            toast(str, 1, false);
            this.isSelect = false;
            this.init();
          } else {
            var str = res.message;
            toast(str, 2, false);
          }
        });
      }
    },
    //批量放入回收站
    putInbin() {
      var arr = [];

      for (var i = 0; i < this.selectItem.length; i++) {
        for (var j = 0; j < this.selectItem[i].shelvesProduct.length; j++) {
          if (
            this.selectItem[i].shelvesProduct[j].isChecked == true &&
            this.selectItem[i].shelvesProduct[j].isSelect == true
          ) {
            arr.push(this.selectItem[i].shelvesProduct[j].goodsId);
          }
        }
        this.bingoodsIds = arr;
      }

      if (this.bingoodsIds.length > 0) {
        const h = this.$createElement;
        this.$msgbox({
          title: "",
          message: h(
            "div",
            {
              style: "text-align:center"
            },
            [
              h(
                "p",
                {
                  style: "color:#494949;font-size:22px"
                },
                "你真的要删除所选商品吗?"
              ),
              h(
                "span",
                {
                  style: "color:#494949;font-size:14px"
                },
                "放入回收站后,对应的商品将无法正常下单"
              )
            ]
          ),
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "再想想",
          confirmButtonClass: "confirmButtonBtn",
          cancelButtonClass: "cancelButtonBtn",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              this.confirmAddcollect();
              done();
            } else {
              done();
            }
          }
        }).then(action => {});
      } else {
        toast("请先选择商品", 3, false);
      }
    },
    //确定放入回收站
    confirmAddcollect() {
      var data = {
        goodsIdList: this.bingoodsIds,
        userId: this.condition.userId,
        appId: localStorage.getItem("appId"),
        bodyId: this.$store.state.bodyId,
      };

      if (this.bingoodsIds.length != 0) {
        var url = batchAddCollect;
        fetch(url, data).then(res => {
          if (res.code == 10000) {
            var str = res.message;
            toast(str, 1, false);
            this.isSelect = false;
            //成功,全部重新获取.延迟点时间,因为删除需要时间.
            setTimeout(() => {
              this.init();
              this.kindgoodsCount();
              this.binFilter();
            }, 1500);
          } else {
            var str = res.message;
            toast(str, 2, false);
          }
        });
      }
    },
    //批量推送未生效信息
    pushIneffective() {
      var data = {};
      data.appId = localStorage.getItem("appId");
      data.userId = store.state.userId;
      data.appId = store.state.appId;
      var url = pushNeedSend;
      console.log(data);
      fetch(url, data).then(res => {
        if (res.code == 10000) {
          var str = res.message;
          toast(str, 1, false);
        } else {
          var str = res.message;
          toast(str, 2, false);
        }
      });
    },
    pushItem(id) {
      var arr = [];
      var opt = {
        goodsAppRecordId: id
      };
      arr.push(opt);
      this.goodAppRecordIds = arr;
      var data = {
        goodsAppRecordList: this.goodAppRecordIds,
        sendUpdateGoods: 0,
        sendUpdateGoodsDetail: 0,
        sendUpdateSalePrice: 0,
        userId: this.condition.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      console.log(data);
      if (this.sendUpdateGoods == true) {
        data.sendUpdateGoods = 1;
      } else {
        data.sendUpdateGoods = 0;
      }

      if (this.sendUpdateGoodsDetail == true) {
        data.sendUpdateGoodsDetail = 1;
      } else {
        data.sendUpdateGoodsDetail = 0;
      }

      if (this.sendUpdateSalePrice == true) {
        data.sendUpdateSalePrice = 1;
      } else {
        data.sendUpdateSalePrice = 0;
      }

      var url = send;
      fetch(url, data).then(res => {
        if (res.code == 10000) {
          var str = res.message;
          toast(str, 1, false);

          setTimeout(() => {
            this.init();
            this.kindgoodsCount();
            this.binFilter();
          }, 1500);
        } else {
          var str = res.message;
          toast(str, 2, false);
        }
      });
    },
    // 加入采购车
    joinCar(row, value) {
      console.log("加入采购车");
      console.log(row);
      this.addCarShowFlag = true;
      this.$nextTick(() => {
        this.$refs.addCar.init(row, value);
      });
    },
    // 修改子组件时的回调方法
    updateTableData() {
      this.init();
    },
    clearCondition() {
      this.condition.brandName = "";
      this.condition.goodsName = "";
      this.condition.productId = "";
      this.condition.categoryTwoName = "";
      this.condition.categoryThreeName = "";
      this.condition.pageNum = 1;
      this.init();
    },
    clearbinFilterObj() {
      this.binFilterObj.brandName = "";
      this.binFilterObj.goodsName = "";
      this.binFilterObj.deltime = "";
      this.binFilterObj.categoryTwoName = "";
      this.binFilterObj.categoryThreeName = "";
      this.binFilterObj.pageNum = 1;
      this.binFilter();
    },
    handleCurrentChange(val) {
      this.condition.pageNum = val;
      this.isSelect = false;
      this.init();
    },
    //商品回收站当前页面改变时触发的事件
    handlebinCurrentChange(val) {
      this.binFilterObj.pageNum = val;
      this.binFilter();
    },
    showMask(a, b) {
      this.selectItem[a].shelvesProduct[b].isShow = true;
    },
    hideMask(a, b) {
      this.selectItem[a].shelvesProduct[b].isShow = false;
    },
    activityOption(num, id) {
      if (num == 0) {
        var str = "请先推送！";
        toast(str, 2, false);
        return;
      }
      const data = {
        actOption: num,
        goodsAppRecordId: id,
        userId: this.condition.userId,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };

      // const url = activityOption;

      fetch(url, data).then(res => {
        if (res.code == 10000) {
          var str = "操作成功！";
          toast(str, 1, false);
          this.init();
        } else {
          var str = "操作失败！";
          toast(str, 2, false);
        }
      });
    },
    // ----采购车模块--------
    // 控制订单页面的显影
    handleSwitchPage(index) {
      this.carIndex = index;
    },
    //采购车切换功能
    showShopCar(index) {
      if (index == 2) {
        // this.$router.go(0);
        // setTimeout(() => {
        this.shopCarShow = true;
        //   alert(this.shopCarShowOrder)
        this.carIndex = 1;
      }
    }
  }
};
</script>

<style lang="less">
.shelves-confirm {
  .el-message-box__btns {
    button:nth-child(1) {
      color: black !important;
      background-color: white !important;
      float: left !important;
      border-color: #dcdfe6 !important;
    }
    button:nth-child(2) {
      float: right !important;
      background-color: #fea923 !important;
      color: white !important;
      border-color: #fea923 !important;
    }
  }
}
.shelves-table-block-name {
  vertical-align: middle;
  width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.c-dropdown /deep/.el-button {
  border: 0px;
}

.shelves-input-item {
  width: 300px !important;
  margin-right: 40px !important;
}

.delete-goods-time {
  width: 500px;
}

.delete-time/deep/ {
  .el-date-editor .el-range__icon,
  .el-range-separator {
    line-height: 25px !important;
  }
}

.delete-goods-time {
  margin-left: 0;
  width: 43% !important;
}

.tr.shelves-table-item td:nth-child(2) {
  border-bottom: none !important;
}

.jicai-style {
  padding: 3px 6px;
  background: rgba(255, 248, 249, 1);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(255, 77, 94, 1);
  line-height: 17px;
}

.tr-td-style {
  border-bottom: none !important;

  > td:nth-child(3) {
    border-bottom: none !important;
  }

  > td {
    border-bottom: dotted 1px #e5e5e5 !important;
  }
}

.shelves-table {
  // tr:nth-child(5).shelves-table-item{
  //   > td:nth-child(3) {
  //     border-top: 1px solid #dadada !important;
  //   }
  // }

  tr.shelves-table-item:nth-child(n + 3) {
    > td:nth-child(3) {
      border-top: 1px solid #dadada !important;
    }
  }
}

.el-message-box__btns button:first-child {
  margin-left: 0px !important;
}

.el-message-box .el-button.el-button--default {
  margin-right: 0px !important;
}
.price-control-tips{
  background-color: #F56C6C;
  color: #fff;
  font-size: 10px;
  border-radius: 12px;
  padding: 0 4px;
  box-sizing: border-box;
}
.table-popover{
	&.el-popover{color:#fff; background: rgba(0,0,0,0.5);}
	&.el-popper[x-placement^=top] .popper__arrow::after{border-top-color: rgba(0,0,0,0.5);}
	&.el-popper[x-placement^=bottom] .popper__arrow::after{border-bottom-color: rgba(0,0,0,0.5);}
	.popover-center{text-align: center;}
	.popover-center img{width: 100%;}
}
.radio-setting/deep/ .is-checked {
  span {
    color: #f78d4c !important;
  }
}
.radio-setting/deep/.el-radio__input.is-checked .el-radio__inner {
  background-color: #f78d4c;
  border-color: #f78d4c;
}

.check-list/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #f78d4c;
}

.check-list/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f78d4c;
  border-color: #f78d4c;
}
.radio-setting/deep/.el-radio__input.is-disabled .el-radio__inner {
  background-color: #f2f6fc;
  border-color: #dcdfe6;
}

.check-list/deep/.el-checkbox__input.is-disabled .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f2f6fc;
  border-color: #dcdfe6;
}
.push-content{
  background-color: rgb(255,250,243);
  padding: 10px;
  box-sizing: border-box;
  margin-top: -30px;
  margin-bottom: 30px;
  .push-title{
    color: #fea923;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
  div{
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// Shelves.vue?5707a4b8